import { GlFilteredSearchToken, GlFilteredSearchSuggestion, GlIcon } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { s__ } from '~/locale';
import { glListenersMixin } from '~/lib/utils/vue3compat/gl_listeners_mixin';
import { JOB_RUNNER_TYPE_INSTANCE_TYPE, JOB_RUNNER_TYPE_GROUP_TYPE, JOB_RUNNER_TYPE_PROJECT_TYPE } from '../constants';
export default {
    name: 'JobRunnerTypeToken',
    components: {
        GlFilteredSearchToken,
        GlFilteredSearchSuggestion,
        GlIcon
    },
    mixins: [
        glListenersMixin
    ],
    props: {
        config: {
            type: Object,
            required: true
        },
        value: {
            type: Object,
            required: true
        }
    },
    computed: {
        runnerTypes () {
            return [
                {
                    class: 'ci-runner-runner-type-instance',
                    icon: 'users',
                    text: s__('Runners|Instance'),
                    value: JOB_RUNNER_TYPE_INSTANCE_TYPE
                },
                {
                    class: 'ci-runner-runner-type-group',
                    icon: 'group',
                    text: s__('Runners|Group'),
                    value: JOB_RUNNER_TYPE_GROUP_TYPE
                },
                {
                    class: 'ci-runner-runner-type-project',
                    icon: 'project',
                    text: s__('Runners|Project'),
                    value: JOB_RUNNER_TYPE_PROJECT_TYPE
                }
            ];
        },
        findActiveRunnerType () {
            return this.runnerTypes.find((runnerType)=>runnerType.value === this.value.data);
        }
    }
};
